const initState = {
    serviceOverviewInfo: {},
    serviceStatusOverview: {},
    openItemDetails: {},
};

const SET_SERVICE_OVERVIEW = 'SET_SERVICE_OVERVIEW';
const SET_SERVICE_STATUS_OVERVIEW = 'SET_SERVICE_STATUS_OVERVIEW';
const SET_OPEN_ITEM_DETAILS = 'SET_OPEN_ITEM_DETAILS';

export const setServiceOverviewInfo = (data) => ({ type: SET_SERVICE_OVERVIEW, payload: data });
export const setServiceStatusOverview = (data) => ({
    type: SET_SERVICE_STATUS_OVERVIEW,
    payload: data,
});
export const setOpenItemDetails = (data) => ({ type: SET_OPEN_ITEM_DETAILS, payload: data });

export default (state = initState, action) => {
    switch (action.type) {
        case SET_SERVICE_OVERVIEW:
            return { ...state, serviceOverviewInfo: action.payload };
        case SET_SERVICE_STATUS_OVERVIEW:
            return { ...state, serviceStatusOverview: action.payload };
        case SET_OPEN_ITEM_DETAILS:
            return { ...state, openItemDetails: action.payload };
        default:
            return state;
    }
};
